import { useState, useImperativeHandle, forwardRef, useRef, React, useEffect } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

const AccountPasswordInput = forwardRef((props, ref) => {
	const { className, placeholder, type, clickCountFn, onClickLoginButton, onClickMultiLogin } = props;
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [changedPlaceholderColor, setChangedPlaceholderColor] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		setDefaultPlaceholder: (val) => {
			setDefaultPlaceholder(val)
			setChangedPlaceholderColor(true);
			inputRef.current.style.borderColor = theme.pointRed;
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = theme.line;
		}
	}));

	useEffect(() => {
		clickCountFn(className, clickCount);
	}, [clickCount, value])

	function onClickInput(e) {
		inputRef.current.style.borderColor = theme.primary;
		// setDefaultPlaceholder('');
	}

	function onChangeInput(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function onFocusInput(e) {
		setChangedPlaceholderColor(false);
		if (changed) {
			// do nothing
		}
		else {
			setValue("");
		}
	}

	function onBlurInput(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;

		if (value === "") {
			// setDefaultPlaceholder(placeholder);
			// inputRef.current.style.borderColor = '#FF3131';
		}
		else {
			// inputRef.current.style.borderColor = '#E8E8E8';
		}
	}

	function onKeyDown(e) {
		if (e.keyCode === 13) {
			if (onClickMultiLogin) {
				onClickMultiLogin();
			}
			else if (onClickLoginButton) {
				onClickLoginButton();
			}
		}
	}

	return <Input
		ref={inputRef}
		clickCount={clickCount}
		type={type}
		placeholder={defaultPlaceholder}
		value={value}
		changedColor={changedPlaceholderColor}
    onKeyDown={onKeyDown}
		className={`${className} ${changed ? "changed" : ""}`}
		onClick={onClickInput}
		onChange={onChangeInput}
		onFocus={onFocusInput}
		onBlur={onBlurInput} />
});

export default AccountPasswordInput;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 16px;
	// font-size: max(12px, 0.7291666666666667vw);
	// line-height: 20px;
	
	padding: 0 0 4px 0;
	margin-top: 10px;
	// margin-top: max(12px, 0.8333333333333333vw);

	outline: none;
	border-width: 0 0 1px 0;
	border-color: ${props => props.theme.line};
	color: ${props => props.theme.text};
	background-color: transparent;

	::placeholder {
		color: ${props => props.changedColor ? props.theme.pointRed : props.theme.subText};
	}
	
  transition: all 0.5s ease-in-out;
`;